module.exports = __webpack_public_path__ + "d960c235f7a8f8d84ea944cabc364731.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/wei-Vani.png
// module id = 578
// module chunks = 30